import React from 'react';

export interface ConfirmDialogProps {
  open: boolean;
  title: string;
  message: string;
  confirmLabel?: string;
  cancelLabel?: string;
  onConfirm: () => void;
  onClose: () => void;
  confirmButtonClassName?: string;
  cancelButtonClassName?: string;
}

const ConfirmDialog: React.FC<ConfirmDialogProps> = ({
  open,
  title,
  message,
  confirmLabel = 'Confirmer',
  cancelLabel = 'Annuler',
  onConfirm,
  onClose,
  confirmButtonClassName = 'px-3 py-1.5 text-sm rounded border text-white bg-blue-600 hover:bg-blue-700',
  cancelButtonClassName = 'px-3 py-1.5 text-sm rounded border text-gray-700 bg-gray-50 hover:bg-gray-100',
}) => {
  if (!open) return null;

  const handleConfirm = () => {
    onConfirm();
    onClose();
  };

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center">
      <div className="absolute inset-0 bg-black/30" onClick={onClose} />
      <div className="relative bg-white rounded-md shadow-lg border w-full max-w-sm mx-4 p-4">
        <h4 className="text-sm font-semibold text-gray-900 mb-2">{title}</h4>
        <p className="text-sm text-gray-700 mb-4">{message}</p>
        <div className="flex items-center justify-end gap-2">
          <button onClick={onClose} className={cancelButtonClassName}>
            {cancelLabel}
          </button>
          <button onClick={handleConfirm} className={confirmButtonClassName}>
            {confirmLabel}
          </button>
        </div>
      </div>
    </div>
  );
};

export default ConfirmDialog;

